import { Box, Typography } from '@mui/material'
import { DataValue } from '~/components/Charts/chrome/DataValue'

/** Wave-3 §3/D4: a 1-category × 1-series summary is a NUMBER, not geometry.
 *  Wave-4 §2: the number rides dataValueLg (proportional figures — hero size). */
export function SingleStatTile({ value, label }: { value: number; label: string }) {
  return (
    <Box data-testid="single-stat-tile" sx={{ py: 6, textAlign: 'center' }}>
      <DataValue value={value} size="lg" />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {label}
      </Typography>
    </Box>
  )
}
